module.exports = __webpack_public_path__ + "media/images/pen_antiquewhite-7907e518.png";